import { createSlice } from "@reduxjs/toolkit";

const adminSlice = createSlice
({
    name: 'admin',
    initialState: {
        privileges: undefined,
        userRoles: undefined,
        users: undefined,
        inProgress: false,
        userGroups: undefined,
        approvals: undefined,
        trainings: undefined
    },
    reducers: {
        setProgress: (state: any, action: any) => {
            state.inProgress = action.payload;
        },
        setUserRoles: (state: any, action: any) => {
            state.userRoles = action.payload;
            return;
        },
        setPrivileges: (state: any, action: any) => {
            state.privileges = action.payload;
            return;
        },
        setUsers: (state: any, action: any) => {
            state.users = action.payload;
            return;
        },
        setUserGroups: (state: any, action: any) => {
            state.userGroups = action.payload;
            return
        },
        setApprovalList: (state: any, action: any) => {
            state.approvals = action.payload;
            return
        },
        setTrainingsList: (state: any, action: any) => {
            state.trainings = action.payload;
            return
        }
    }
})

export const { setProgress, setUsers, setPrivileges, setUserRoles, setUserGroups, setApprovalList, setTrainingsList } = adminSlice.actions
export default adminSlice.reducer;